
<div class="inner-adjust">
    <div class="pt-3 pb-2 mb-3 border-bottom">
      <h1>Administration</h1>
    </div>
    <!-- Show user data when logged in -->
    <div class="row">
      <div class="col-md-12">
        <div class="media">
          <div class="media-body">
            <ul *ngFor="let log of logs">
              <li>{{log}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>